import {
  InvoiceQueryFilters,
  InvoiceSortColumns,
  SortOrder,
  EntryType
} from 'openapi';

type FieldNames = 'stages' | 'shortCompanyNames' | 'insertedBy';

export const ALL_COMPANY_REVENUE_FILTER_FIELDS = [
  { name: 'stages' as FieldNames, translationKey: 'labels.stage' },
  {
    name: 'shortCompanyNames' as FieldNames,
    translationKey: 'labels.shortCompanyName'
  },
  { name: 'insertedBy' as FieldNames, translationKey: 'labels.insertedBy' }
];

export const REVENUE_FILTER_FIELDS = [
  { name: 'stages' as FieldNames, translationKey: 'labels.stage' },
  { name: 'insertedBy' as FieldNames, translationKey: 'labels.insertedBy' }
];

export const REVENUE_FILTERS_DEFAULT_VALUES = {
  stages: [],
  shortCompanyNames: [],
  insertedBy: [],
  invoiceDateFrom: null,
  invoiceDateTo: null,
  uploadedDateFrom: null,
  uploadedDateTo: null,
  amountFrom: '',
  amountTo: '',
  documentTypes: [],
  documentNumber: '',
  tags: []
};

export const INITIAL_SORT = {
  sortBy: InvoiceSortColumns.INSERTED_AT,
  sortOrder: SortOrder.DESC
};

export const INITIAL_REVENUE_FILTERS: InvoiceQueryFilters = {
  ...INITIAL_SORT,
  amount: {},
  invoiceDate: {},
  uploadedDate: {},
  entryType: EntryType.REVENUE
};
